import { usePage } from "@inertiajs/inertia-react";
import { useQuery } from "@tanstack/react-query";
import { getCookieValue } from "../utils/getCookieValue";

export function useSyncOrderState({ queryKey = "order" }) {
    const { query } = usePage().props;
    const orderNumber = query?.number;
    const { data, isLoading: isMetadataLoading } = useQuery({
        queryKey: [queryKey, "metadata", orderNumber],
        enabled: !!orderNumber,
        queryFn: async () => {
            const res = await fetch(
                route("order.metadata", {
                    order_number: orderNumber,
                }),
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "X-XSRF-TOKEN": getCookieValue("XSRF-TOKEN"),
                        "X-Requested-With": "XMLHttpRequest",
                    },
                }
            );

            const json = await res.json();

            return json;
        },
    });

    return {
        defaultFormValues: data?.data?.formValues,
        defaultOrderEntryState: data?.data?.orderEntryState,
        isMetadataLoading,
        hasOrderNumber: !!orderNumber,
    };
}
